/* Shared react-data-table-component theme for V3 admin pages.
   Pass as <DataTable customStyles={v3DataTableStyles} ... />.
   Uses CSS custom properties so it follows the active light/dark theme. */

const v3DataTableStyles = {
    table: { style: { background: 'transparent' } },
    tableWrapper: { style: { background: 'transparent' } },
    headRow: {
        style: {
            background: 'var(--v3-bg-surface)',
            borderBottomColor: 'var(--v3-glass-border)',
            minHeight: '42px',
        },
    },
    headCells: {
        style: {
            color: 'var(--v3-text-muted)',
            textTransform: 'uppercase',
            fontSize: '11px',
            letterSpacing: '0.04em',
            fontWeight: 600,
        },
    },
    rows: {
        style: {
            background: 'transparent',
            color: 'var(--v3-text-secondary)',
            minHeight: '46px',
            borderBottomColor: 'var(--v3-glass-border)',
            fontSize: '13px',
        },
        highlightOnHoverStyle: {
            backgroundColor: 'var(--v3-bg-surface)',
            color: 'var(--v3-text-primary)',
            borderBottomColor: 'var(--v3-glass-border)',
            outline: 'none',
        },
        stripedStyle: { background: 'var(--v3-bg-glass)' },
    },
    cells: { style: { color: 'var(--v3-text-secondary)' } },
    pagination: {
        style: {
            background: 'transparent',
            color: 'var(--v3-text-secondary)',
            borderTopColor: 'var(--v3-glass-border)',
        },
        pageButtonsStyle: {
            color: 'var(--v3-text-secondary)',
            fill: 'var(--v3-text-secondary)',
        },
    },
    noData: { style: { background: 'transparent', color: 'var(--v3-text-muted)', padding: '32px' } },
    progress: { style: { background: 'transparent', color: 'var(--v3-text-muted)' } },
};

export default v3DataTableStyles;
